import { formatNumber } from './number';

export { formatNumber };

export function formatDateTime(iso: string | null): string | null {
    if (!iso) {
        return null;
    }

    const date = new Date(iso);

    if (Number.isNaN(date.getTime())) {
        return null;
    }

    return date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

/** «3 420 из 10 000» — расход лимита запросов организации. */
export function formatLimit(used: number, limit: number): string {
    return `${formatNumber(used)} из ${formatNumber(limit)}`;
}

/** ISO → «27.07.2026» без времени. */
export function formatDate(iso: string): string {
    const date = new Date(iso);

    if (Number.isNaN(date.getTime())) {
        return iso;
    }

    return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
